module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"title":"Termos de Uso","home":"Home"},"en":{"title":"Terms of Use","home":"Home"},"es":{"title":"Términos de uso","home":"Inicio"}}')
  delete Component.options._Ctor
}
